var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLPsGIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7015 10.9828L4.35623 0.609375L17.5187 8.16562L14.7015 10.9828ZM1.65623 0C1.04685 0.31875 0.639038 0.9 0.639038 1.65469V22.3406C0.639038 23.0953 1.04685 23.6766 1.65623 23.9953L13.6844 11.9953L1.65623 0ZM21.5875 10.575L18.8265 8.97656L15.7469 12L18.8265 15.0234L21.6437 13.425C22.4875 12.7547 22.4875 11.2453 21.5875 10.575ZM4.35623 23.3906L17.5187 15.8344L14.7015 13.0172L4.35623 23.3906Z",
    fill: "#059669"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLPsGIcon);
export default __webpack_public_path__ + "static/media/l_ps_g_icon.7d52867fd8cf3a2da44c71ca689e7527.svg";
export { ForwardRef as ReactComponent };